import flexgap from "./flexgap.es.js";
const features = [flexgap];
export {
  features as default
};
//# sourceMappingURL=index.es.js.map
